<script setup>
  defineOptions({
    name: "MergeAccountStepDivider",
  });
</script>

<template>
  <li class="flex flex-col items-center md:flex-row">
    <slot />
  </li>
</template>
